import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: calc(100vh - 161px);

  .page {
    padding: 24px 16px;
    padding-bottom: 40px;
    z-index: 10;
    animation: none;
    transform: none;
  }

  .delivery-zones-info {
    background: ${props => props.theme.accent}22;
    padding: 8px;
  }

  .trial-expiry-tag {
    background: linear-gradient(120deg, #ff6722, #fd8c66);
    border-radius: 16px;
    padding: 4px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${props => props.theme.white};
    font-weight: 600;
    font-size: 16px;
    transition: all 0.2s ease-in-out;
    margin-top: 24px;
    text-align: center;
  }

  .banner {
    width: calc(100% - 2px);
    color: ${props => props.theme.white};
    background: linear-gradient(20deg, hsl(206deg 100% 50%), hsl(192deg 98% 52%));

    padding: 50px 8px;
    font-weight: 700;
    font-size: 22px;
    padding-bottom: 40px;
    text-align: center;
    position: relative;
    overflow: hidden;
    margin-top: -32px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .mode-toggle-container {
      width: 100%;
      max-width: 350px;
      margin-top: 16px;
    }
  }

  h2 {
    font-size: 20px;
    font-weight: 400;
    width: 100%;
    text-align: left;
  }

  .panel {
    width: 100%;
    box-shadow: 0px 0 16px ${props => props.theme.middleShadow};
  }

  p {
    padding: 8px 0;
    line-height: 22px;
    text-align: center;
  }

  .settings {
    box-shadow: 0px 0 16px ${props => props.theme.middleShadow};
  }

  .module-overview {
    background: ${props => props.theme.white};
    flex-direction: column;
    padding: 24px;
    padding-bottom: 24px;
    margin: 0 1px;

    .header {
      margin: -24px;
      padding: 24px 20px;
      cursor: pointer;

      &:hover {
        background: ${props => props.theme.pageBackground}66;
      }

      .title {
        display: flex;
        align-items: center;
        gap: 10px;

        .chevron {
          font-size: 14px;
          color: ${props => props.theme.accent};
          transition: transform 0.3s ease;
        }
      }
    }

    &.collapsed .header .title .chevron {
      transform: rotate(-90deg);
    }

    .collapsable {
      max-height: 1200px;
      transition: max-height 0.3s cubic-bezier(0.25, 1, 0.32, 1);

      .collapsable-content {
        display: flex;
        flex-direction: column;
      }
    }

    &.collapsed {
      cursor: pointer;

      .title {
        font-size: 16px;
      }

      .images {
        opacity: 0;
      }

      .collapsable {
        max-height: 0;
        overflow: hidden;
      }
    }
  }

  .shadow-container {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    /* box-shadow: 0px 0 16px ${props => props.theme.middleShadow}; */
    background: ${props => props.theme.white};

    &.disabled {
      box-shadow: inset 0 4px 12px ${props => props.theme.shadow};
      background: ${props => props.theme.activeBackground};
    }
  }

  .setting {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    box-shadow: 0 0px 12px ${props => props.theme.mutedText}44;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    transition: all 0.2s cubic-bezier(0.25, 1, 0.32, 1);
    box-shadow: none;
    /* padding: 16px 8px; */
    border-top: 1px solid ${props => props.theme.border};
    width: 100%;

    .setting-name {
      display: flex;
      align-items: center;
    }

    input {
      padding-right: 12px;
    }

    &.grouped {
      &:last-of-type {
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
      }
    }

    &.disabled {
      background: ${props => props.theme.activeBackground};

      img {
        filter: saturate(0);
      }

      .right-side {
        cursor: not-allowed;
      }

      .react-toggle-wrapper {
        pointer-events: none;
        cursor: not-allowed;
      }
    }

    .setting-icon {
      width: 24px;
      height: 24px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      font-size: 13px;

      img {
        width: 24px;
      }
    }
  }

  .background-emoji.right {
    right: -60px;
    left: auto;
    bottom: -60px;
    /* transform: rotate(-20deg); */
    font-size: 200px;
  }

  .react-toggle-wrapper {
    margin-top: 0;
  }

  .images {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
    margin-top: 16px;
    margin-bottom: 20px;
    transition: all 0.3s ease-in-out;
    overflow: visible;

    .image-wrapper {
      flex: 1;
      position: relative;
      height: 100px;
      min-width: 0;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        display: block;
      }

      &::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 6px;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 11px 4px inset;
        pointer-events: none;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }

      &:hover {
        transform: scale(1.05);
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .image-preview {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    padding-top: 16px;
    animation: fadeIn 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;

    img {
      width: 320px;
      height: auto;
      border-radius: 12px;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translateX(-50%) scale(0.95);
      }
      to {
        opacity: 1;
        transform: translateX(-50%) scale(1);
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .info-blocks {
    margin-top: 8px;
    padding-left: 16px;

    .info-block {
      padding: 12px 0;
      font-size: 16px;
      line-height: 20px;

      .info-explainer {
        font-size: 14px;
        color: ${props => props.theme.red};
        margin-top: 4px;
        display: inline-block;

        svg {
          margin-right: 4px;
          /* margin-left: 16px; */
        }
      }

      &:last-of-type {
        padding-bottom: 0;
      }

      .qr-button {
        display: inline-block;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 12px;
        box-shadow: 0 2px 12px #0002;
        padding: 2px 12px;
        border-radius: 8px;
        margin-right: 8px;
        margin-left: 8px;
        cursor: pointer;

        :hover {
          background-color: ${props => props.theme.activeBackground};
        }

        .icon {
          margin-left: 4px;
        }
      }
    }
  }

  .new-tag {
    display: inline-block;
    background: ${props => props.theme.blue};
    padding: 1px 5px;
    color: #fff;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    margin-right: 4px;
  }

  .toggle,
  .bullet {
    margin-left: 8px;
    flex-shrink: 0;
    margin-bottom: 0;
  }

  .device {
    box-shadow: 0 4px 12px ${props => props.theme.shadow};
    background: ${props => props.theme.white};
    border-radius: 8px;
    padding: 10px 16px;
    margin: 0 8px;
    border: 1px solid ${props => props.theme.border};
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    font-weight: 500;
    color: ${props => props.theme.normalText};
    margin-top: 16px;
    display: flex;
    align-items: center;
    width: min(400px, 100vw - 70px);
    justify-content: space-between;
    position: relative;

    button {
      margin-top: 0;
      padding: 0px;
    }

    .notifications-badge {
      height: 21px;
      width: 21px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;
      border-radius: 24px;
      position: absolute;
      left: -12px;
      margin: auto;
      top: 0;
      bottom: 0;

      svg {
        color: ${props => props.theme.white};
        font-size: 12px;
      }

      &.red {
        background: ${props => props.theme.red};
      }

      &.green {
        background: ${props => props.theme.green};
      }
    }

    .device-info {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-right: 24px;

      .waiter-name {
        font-weight: 700;
        text-align: left;

        .notifications-off {
          display: inline-block;
          font-weight: 500;
          font-size: 14px;
          vertical-align: text-top;
          color: ${props => props.theme.red};
        }
      }

      .device-type {
        text-transform: capitalize;
        margin-top: 4px;
        text-align: left;

        img {
          height: 16px;
          margin-right: 5px;
          float: left;
        }
      }
    }
  }
`
